<template>
    <div class="News">
        <app-menu :active.sync="menuOpened" :bottom="true"  />
        <top-navbar :menu-opened.sync="menuOpened" />
        <div class="site-section-h">
            <breadcrumb :links="[{title: 'Eventos', to: {path: $route.path}}]" />
        </div>
        <div class="news-content site-section-h">
            <div class="content">
                <h2 class="title-with-icon m-b">
                    <img src="@/assets/img/svg/articles.svg" width="15">
                    Notícias
                </h2>

                <section class="news-list-item" v-for="item in news" :key="`new-item-id-${item.id}`">
                    <small class="date">20/07/2020</small>
                    <h4>{{ item.title }}</h4>
                    <p>{{ item.text }}</p>
                    <p>Fonte: Juriste</p>
                </section>
                <newsletter />
            </div>
            <nav class="sidebar">
                <h4 class="title-with-icon m-b">
                    <img src="@/assets/img/svg/video.svg" width="20">
                    Vídeos
                </h4>
                <post-card :post="video" type="video" />
                <hr>
                <logo-card theme="orange">
                    <strong>Agende atendimento</strong> com um advogado.
                </logo-card>
                <hr>
                <post-links icon="most_read" title="MAIS LIDOS" :links="links"></post-links>
                <hr>
                <logo-card theme="blue">
                    Está com alguma <strong>dúvida jurídica</strong>?
                </logo-card>
                <hr>
                    <post-links icon="podcast" title="PODCAST" :links="links">
                    </post-links>
                <hr>
            </nav>
        </div>
    </div>
</template>

<script>
import AppMenu from "@/components/Menu";
import TopNavbar from "@/components/Blog/TopNavbar";
import Breadcrumb from "@/components/Breadcrumb";
import LogoCard from "@/components/LogoCard";
import PostCard from "@/components/Blog/PostCard";
import PostLinks from "@/components/Blog/PostLinks";
import Newsletter from "@/components/Blog/Newsletter";

export default {

    components: {
        AppMenu,
        TopNavbar,
        Breadcrumb,
        LogoCard,
        Newsletter,
        PostCard,
        PostLinks,
    },

    async created() {
        this.loadNews()

        this.video = {
            title: 'A Atualização Do CNIS Pelos Canais Virtuais Do INSS Durante A Pandemia E O Planejamento Da Aposentadoria',
            image: 'https://www.placecage.com/800/400',
            author: 'Wallace de Souza',
        };

        this.links = [
            {
                title: 'Estratégias em um Novo Paradigma Globalizado',
                date: '13 jul 2020',
                href: 'estrategia-em-um-novo-paradigma-globalizado'
            },
            {
                title: 'Estratégias em um Novo Paradigma Globalizado',
                date: '13 jul 2020',
                href: 'estrategia-em-um-novo-paradigma-globalizado'
            },
            {
                title: 'Estratégias em um Novo Paradigma Globalizado',
                date: '13 jul 2020',
                href: 'estrategia-em-um-novo-paradigma-globalizado'
            }
        ];

    },

    data() {
        return {
            menuOpened: false,
            news: [],
            video: {},
            links: [],
        }
    },


    methods: {
        async loadNews() {



            const news = [{
                    title: 'Estratégias em um Novo Paradigma Globalizado',
                    text: `O presidente do Supremo Tribunal Federal (STF), ministro Dias Toffoli, suspendeu hoje (29) duas investigações abertas pela Justiça de São Paulo
contra o senador José Serra (PSDB-SP) para apurar supostas doações ilegais de campanha. A decisão atende ao pedido da defesa, que defende que o
caso seja transferido para o STF.`,
                    id: 1
                },
                {
                    title: 'Estratégias em um Novo Paradigma Globalizado',
                    text: `O presidente do Supremo Tribunal Federal (STF), ministro Dias Toffoli, suspendeu hoje (29) duas investigações abertas pela Justiça de São Paulo
contra o senador José Serra (PSDB-SP) para apurar supostas doações ilegais de campanha. A decisão atende ao pedido da defesa, que defende que o
caso seja transferido para o STF.`,
                    id: 2
                },
                {
                    title: 'Estratégias em um Novo Paradigma Globalizado',
                    text: `O presidente do Supremo Tribunal Federal (STF), ministro Dias Toffoli, suspendeu hoje (29) duas investigações abertas pela Justiça de São Paulo
contra o senador José Serra (PSDB-SP) para apurar supostas doações ilegais de campanha. A decisão atende ao pedido da defesa, que defende que o
caso seja transferido para o STF.`,
                    id: 3
                },
                {
                    title: 'Estratégias em um Novo Paradigma Globalizado',
                    text: `O presidente do Supremo Tribunal Federal (STF), ministro Dias Toffoli, suspendeu hoje (29) duas investigações abertas pela Justiça de São Paulo
contra o senador José Serra (PSDB-SP) para apurar supostas doações ilegais de campanha. A decisão atende ao pedido da defesa, que defende que o
caso seja transferido para o STF.`,
                    id: 4
                },
                {
                    title: 'Estratégias em um Novo Paradigma Globalizado',
                    text: `O presidente do Supremo Tribunal Federal (STF), ministro Dias Toffoli, suspendeu hoje (29) duas investigações abertas pela Justiça de São Paulo
contra o senador José Serra (PSDB-SP) para apurar supostas doações ilegais de campanha. A decisão atende ao pedido da defesa, que defende que o
caso seja transferido para o STF.`,
                    id: 5
                },
                {
                    title: 'Estratégias em um Novo Paradigma Globalizado',
                    text: `Como Deleuze eloquentemente mostrou, o início da atividade geral de formação de conceitos obstaculiza a apreciação da importância dos paradigmas filosóficos. Bergson mostrou que os sistemas mecanicistas, ainda em voga, provocam a bipolaridade do valor proposicional não oferece uma interessante oportunidade para verificação dos relacionamentos verticais entre as hierarquias conceituais. Se estivesse vivo, Foucault diria que a revolução dos costumes é uma das consequências do processo de comunicação como um todo. Por conseguinte, a expansão dos mercados mundiais pode nos levar a considerar a reestruturação das ciências discursivas.`,
                    id: 6
                },
            ];


            this.news = news;
        }
    }



}
</script>

<style>

</style>
